let progressToast = null;

export function setProgressToast(toast) {
    if (progressToast) {
        progressToast.goAway();
    }
    progressToast = toast;
}

export function getProgressToast() {
    return progressToast;
}

export function clearProgressToast() {
    if (progressToast) {
        progressToast.goAway();
        progressToast = null;
    }
}
